export const images = {
    icon: 'Images/wfdIcon.png',
    mail: 'Images/mail.png',
    wfdPhone: 'Images/wfdPhone.png',
    googlePlayBadge: 'Images/googlePlayBadge.png',
    appStoreBadge: 'Images/appStoreBadge.png',
};
